"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styled_1 = require("./styled");
var LinkUrlInput = /** @class */ (function (_super) {
    __extends(LinkUrlInput, _super);
    function LinkUrlInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleKeyDown = function (e) {
            var _a = _this.props, onConfirm = _a.onConfirm, onDismiss = _a.onDismiss, value = _a.value;
            if (e.keyCode === 13 && onConfirm && value) {
                e.preventDefault();
                e.stopPropagation();
                onConfirm();
            }
            else if (e.keyCode === 27 && onDismiss) {
                e.preventDefault();
                e.stopPropagation();
                onDismiss();
            }
        };
        return _this;
    }
    LinkUrlInput.prototype.componentDidMount = function () {
        var _this = this;
        setTimeout(function () { return _this.editor && _this.editor.focus(); }, 100);
    };
    LinkUrlInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, onChange = _a.onChange, value = _a.value, placeholder = _a.placeholder, theme = _a.theme, wrapperComponent = _a.wrapperComponent, inputComponent = _a.inputComponent;
        var URLInputWrapperComp = wrapperComponent || styled_1.URLInputWrapper;
        var URLInputComp = inputComponent || styled_1.URLInput;
        var plactholderText = placeholder || 'Input url ...';
        return theme
            ? React.createElement("div", { className: theme.wrapper },
                React.createElement("input", { ref: function (ref) { return _this.editor = ref; }, className: theme.input, onKeyDown: this.handleKeyDown, onChange: onChange, value: value, placeholder: plactholderText }))
            : React.createElement(URLInputWrapperComp, null,
                React.createElement(URLInputComp, { innerRef: function (ref) { return _this.editor = ref; }, onKeyDown: this.handleKeyDown, onChange: onChange, value: value, placeholder: plactholderText }));
    };
    return LinkUrlInput;
}(React.Component));
exports.default = LinkUrlInput;
